<div class="standard-page-layout">
  <h1>
    <img width="23" height="23" src="/assets/podcast.svg" />
    Podcasts
  </h1>

  @if (!shows) {
    <app-spinner></app-spinner>
  }
  @if (shows) {
    <section class="podcasts">
      @for (show of shows; track show) {
        <tyt-podcast-item [attr.data-show]="show.id" [class.above-the-fold]="isAboveFold(show)"
          [class.active]="topShowId === show.id" [show]="show">
        </tyt-podcast-item>
      }
    </section>
  }
</div>